import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EnumValue, Enum } from 'ts-enums';
import HTTPMethod from 'http-method-enum';

const IMAGE_SIZE_PARAM_NAME = 'imageSize';
const VERSION_QUERY_PARAM_NAME = 'v';
const TEXTBOOK_EDITOR_PREVIEW_ENV_SUFFIX = '/preview';
// TODO Użycie TextbookClientEndpointEnum dla ścieżek do usług, przykład poniżej...
class TextbookClient {
    constructor(httpClient, apiUrl, editorPreviewMode = false) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.editorPreviewMode = editorPreviewMode;
        this.modeAdjustedApiUrl = editorPreviewMode ? `${this.apiUrl}${TEXTBOOK_EDITOR_PREVIEW_ENV_SUFFIX}` : this.apiUrl;
    }
    getTextbooks$() {
        return this.httpClient
            // TODO `${this.modeAdjustedApiUrl}/textbooks` -> `${this.modeAdjustedApiUrl}${TextbookClientEndpointEnum.GET_TEXTBOOKS.url}`
            .get(`${this.modeAdjustedApiUrl}/textbooks`)
            .pipe(map((response) => response.data));
    }
    getTextbook$(textbookId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}`)
            .pipe(map((response) => response.data));
    }
    getInfographic$(textbookId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}`)
            .pipe(map((response) => response.data));
    }
    getTextbookDemo$(textbookDemoId) {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookDemoId}`).pipe(map((response) => response.data));
    }
    getTextbookPages$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/pages`, textbookVersion);
        return this.httpClient
            .get(url)
            .pipe(map((response) => response.data));
    }
    getInfographicPages$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}/pages`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookDemoPages$(textbookDemoId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookDemoId}/pages`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookTextualPages$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/textual-pages`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getInfographicTextualPages$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}/textual-pages`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookDemoTextualPages$(textbookDemoId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookDemoId}/textual-pages`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookPageById$(textbookPageId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbook-pages/${textbookPageId}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookPageByTextbookIdAndPageNumber$(textbookId, pageNumber, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/pages/${pageNumber}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookActionGroups$(textbookId, textbookVersion, accessId) {
        const query = typeof (accessId) !== 'undefined' ? `?accessId=${accessId}` : '';
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/action-groups${query}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getInfographicActionGroups$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}/action-groups`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookDemoActionGroups$(textbookDemoId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookDemoId}/action-groups`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookActions$(textbookId, textbookVersion, accessId) {
        const query = typeof (accessId) !== 'undefined' ? `?accessId=${accessId}` : '';
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/actions${query}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getInfographicActions$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}/actions`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookDemoActions$(textbookDemoId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookDemoId}/actions`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookActionTriggers$(textbookId, textbookVersion, accessId) {
        const query = typeof (accessId) !== 'undefined' ? `?accessId=${accessId}` : '';
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/action-triggers${query}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getInfographicActionTriggers$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}/action-triggers`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookDemoActionTriggers$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookId}/action-triggers`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookActionById$(actionId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbook-actions/${actionId}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getInfographicActionById$(textbookId, actionId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}/actions/${actionId}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookDemoActionById$(textbookDemoId, actionId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookDemoId}/actions/${actionId}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookLegend$(textbookId, textbookVersion, accessId) {
        const query = typeof (accessId) !== 'undefined' ? `?accessId=${accessId}` : '';
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/legend${query}`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getInfographicLegend$(textbookId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/infographic-textbooks/${textbookId}/legend`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getTextbookDemoLegend$(textbookDemoId, textbookVersion) {
        const url = this.buildUrlWithVersionParam(`${this.modeAdjustedApiUrl}/demo-textbooks/${textbookDemoId}/legend`, textbookVersion);
        return this.httpClient.get(url).pipe(map((response) => response.data));
    }
    getResource$(resourceId, imageSize) {
        const url = imageSize === null
            ? this.getResourceUrl(resourceId)
            : `${this.getResourceUrl(resourceId)}?${IMAGE_SIZE_PARAM_NAME}=${imageSize}`;
        return this.httpClient.get(url, {
            responseType: 'blob',
        });
    }
    getResourceUrl(resourceId) {
        return `${this.modeAdjustedApiUrl}/resources/${resourceId}`;
    }
    getResources$(textbookId, ids, imageSize) {
        const queryParamsObj = { 'ids[]': ids };
        if (imageSize) {
            queryParamsObj[IMAGE_SIZE_PARAM_NAME] = imageSize;
        }
        const queryParams = new HttpParams({ fromObject: queryParamsObj });
        const url = this.getResourcesUrl(textbookId);
        return this.httpClient.get(url, { params: queryParams })
            .pipe(map((response) => response.data));
    }
    getResourcesUrl(textbookId) {
        return `${this.modeAdjustedApiUrl}/textbooks/${textbookId}/resources`;
    }
    createMarker$(accessId, pageId, distanceFromTop, distanceFromLeft, width, height) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/markers`, {
            accessId,
            pageId,
            distanceFromTop,
            distanceFromLeft,
            width,
            height
        }).pipe(map((response) => response.data));
    }
    updateMarker$(markerId, accessId, distanceFromTop, distanceFromLeft, width, height) {
        return this.httpClient.patch(`${this.modeAdjustedApiUrl}/markers/${markerId}`, {
            accessId,
            distanceFromTop,
            distanceFromLeft,
            width,
            height,
        }).pipe(map((response) => response.data));
    }
    deleteMarker$(markerId, accessId) {
        return this.httpClient.delete(`${this.modeAdjustedApiUrl}/markers/${markerId}?accessId=${accessId}`);
    }
    getMarkers$() {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/markers`)
            .pipe(map((response) => response.data));
    }
    getTextbookMarkers$(textbookId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/markers`)
            .pipe(map((response) => response.data));
    }
    getTextbookPageMarkers$(textbookPageId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/textbook-pages/${textbookPageId}/markers`)
            .pipe(map((response) => response.data));
    }
    createNote$(accessId, pageId, distanceFromTop, distanceFromLeft, content) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/notes`, {
            accessId,
            pageId,
            distanceFromTop,
            distanceFromLeft,
            content
        }).pipe(map((response) => response.data));
    }
    updateNote$(noteId, accessId, distanceFromTop, distanceFromLeft, content) {
        return this.httpClient.patch(`${this.modeAdjustedApiUrl}/notes/${noteId}`, Object.assign({ accessId,
            distanceFromTop,
            distanceFromLeft }, (typeof content !== 'undefined') && { content })).pipe(map((response) => response.data));
    }
    deleteNote$(noteId, accessId) {
        return this.httpClient.delete(`${this.modeAdjustedApiUrl}/notes/${noteId}?accessId=${accessId}`);
    }
    getNotes$() {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/notes`)
            .pipe(map((response) => response.data));
    }
    getTextbookNotes$(textbookId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/notes`)
            .pipe(map((response) => response.data));
    }
    getTextbookPageNotes$(textbookPageId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/textbook-pages/${textbookPageId}/notes`)
            .pipe(map((response) => response.data));
    }
    getActionNote$(actionId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/textbook-actions/${actionId}/action-note`)
            .pipe(map((response) => response.data));
    }
    getAllActionNotes$() {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/action-notes`)
            .pipe(map((response) => response.data));
    }
    getTextbookActionNotes$(textbookId) {
        return this.httpClient
            .get(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/action-notes`)
            .pipe(map((response) => response.data));
    }
    createActionNote$(accessId, actionId, notes) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/action-notes`, {
            accessId,
            actionId,
            notes,
        }).pipe(map((response) => response.data));
    }
    updateActionNote$(actionNoteId, accessId, notes) {
        return this.httpClient.patch(`${this.modeAdjustedApiUrl}/action-notes/${actionNoteId}`, {
            accessId,
            notes,
        }).pipe(map((response) => response.data));
    }
    deleteActionNote$(noteId, accessId) {
        return this.httpClient.delete(`${this.modeAdjustedApiUrl}/action-notes/${noteId}?accessId=${accessId}`);
    }
    loginWithCredentials$(login, password) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/user-tokens`, { login, password }).pipe(map((response) => response.data));
    }
    loginWithToken$(token, accessId) {
        const body = !!accessId ? { token } : { token, accessId };
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/user-tokens`, body).pipe(map((response) => response.data));
    }
    getAuthenticatedUser$() {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/users/me`)
            .pipe(map((response) => response.data));
    }
    recreateAuthenticatedUser$(accessId) {
        const body = !!accessId ? { accessId } : {};
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/users/me`, body)
            .pipe(map((response) => response.data));
    }
    recreateUserToken$() {
        return this.httpClient.patch(`${this.modeAdjustedApiUrl}/user-tokens`, {})
            .pipe(map((response) => response.data));
    }
    logout$() {
        return this.httpClient.delete(`${this.modeAdjustedApiUrl}/user-tokens`);
    }
    runTextbookAccess$(accessId) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/user-textbook-accesses/${accessId}/run`, {});
    }
    downloadTextbookAccess$(accessId) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/user-textbook-accesses/${accessId}/download`, {});
    }
    uninstallManyTextbookAccesses$(accessIds) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/user-textbook-accesses/uninstall`, { accessIds });
    }
    createDrawing$(accessId, actionId, content) {
        return this.httpClient.post(`${this.modeAdjustedApiUrl}/drawings`, {
            accessId,
            actionId,
            content,
        }).pipe(map((response) => response.data));
    }
    updateDrawing$(drawingId, accessId, content) {
        return this.httpClient.patch(`${this.modeAdjustedApiUrl}/drawings/${drawingId}`, {
            accessId,
            content,
        }).pipe(map((response) => response.data));
    }
    deleteDrawing$(drawingId, accessId) {
        return this.httpClient.delete(`${this.modeAdjustedApiUrl}/drawings/${drawingId}?accessId=${accessId}`);
    }
    getDrawings$() {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/drawings`).pipe(map((response) => response.data));
    }
    getSingleDrawing$(drawingId) {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/drawings/${drawingId}`).pipe(map((response) => response.data));
    }
    getTextbookDrawings$(textbookId) {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/textbooks/${textbookId}/drawings`).pipe(map((response) => response.data));
    }
    getActionDrawing$(actionId) {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/textbook-actions/${actionId}/drawing`).pipe(map((response) => response.data));
    }
    getTextbookPremiumRedirection$(textbookId) {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/premium-textbook-redirections/${textbookId}`).pipe(map((response) => response.data));
    }
    getAppMessage(appVersion) {
        return this.httpClient.get(`${this.modeAdjustedApiUrl}/app-message?appVersion=${appVersion}`).pipe(map((response) => (response === null || response === void 0 ? void 0 : response.data) || null));
    }
    getInteractionAssetUrl$(interactionId) {
        return `${this.modeAdjustedApiUrl}/assets/interactions/${interactionId}`;
    }
    buildUrlWithVersionParam(url, textbookVersion) {
        const queryParamsStartChar = '?';
        const versionQueryParam = `${VERSION_QUERY_PARAM_NAME}=${textbookVersion}`;
        if (!url.includes(queryParamsStartChar)) {
            return `${url}?${versionQueryParam}`;
        }
        return `${url}&${versionQueryParam}`;
    }
}

var ActionType;
(function (ActionType) {
    ActionType["Zoom"] = "zoom";
    ActionType["Gallery"] = "gallery";
    ActionType["Hyperlink"] = "hyperlink";
    ActionType["Audio"] = "audio";
    ActionType["Link"] = "link";
    ActionType["Video"] = "video";
    ActionType["Document"] = "document";
    ActionType["DocumentInline"] = "documentInline";
    ActionType["TeacherComment"] = "teacherComment";
    ActionType["Interaction"] = "interaction";
    ActionType["SelfcheckExercise"] = "selfcheckExercise";
    ActionType["Exercise"] = "exercise";
})(ActionType || (ActionType = {}));

var MessageTypeEnum;
(function (MessageTypeEnum) {
    MessageTypeEnum["LOCK"] = "LOCK";
    MessageTypeEnum["WARNING"] = "WARNING";
})(MessageTypeEnum || (MessageTypeEnum = {}));

var MessagePeriodicityEnum;
(function (MessagePeriodicityEnum) {
    MessagePeriodicityEnum["HOURLY"] = "HOURLY";
    MessagePeriodicityEnum["DAILY"] = "DAILY";
    MessagePeriodicityEnum["WEEKLY"] = "WEEKLY";
    MessagePeriodicityEnum["MONTHLY"] = "MONTHLY";
})(MessagePeriodicityEnum || (MessagePeriodicityEnum = {}));

var UrlParams;
(function (UrlParams) {
    UrlParams["TEXTBOOK_ID"] = "{textbookId}";
    UrlParams["TEXTBOOK_DEMO_ID"] = "{textbookDemoId}";
    UrlParams["TEXTBOOK_PAGE_ID"] = "{textbookPageId}";
    UrlParams["PAGE_NUMBER"] = "{pageNumber}";
    UrlParams["ACTION_ID"] = "{actionId}";
    UrlParams["RESOURCE_ID"] = "{resourceId}";
    UrlParams["MARKER_ID"] = "{markerId}";
    UrlParams["NOTE_ID"] = "{noteId}";
    UrlParams["ACTION_NOTE_ID"] = "{actionNoteId}";
    UrlParams["ACCESS_ID"] = "{accessId}";
    UrlParams["DRAWING_ID"] = "{drawingId}";
})(UrlParams || (UrlParams = {}));
class TextbookClientEndpoint extends EnumValue {
    constructor(url, method = HTTPMethod.GET) {
        super(TextbookClientEndpoint.buildDescription(url, method));
        this.method = method;
        this.url = url;
    }
    static buildDescription(url, method) {
        return `${method}-${url}`;
    }
}
class TextbookClientEndpointEnumType extends Enum {
    constructor() {
        super();
        this.GET_TEXTBOOKS = new TextbookClientEndpoint(`/textbooks`);
        this.GET_TEXTBOOK = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}`);
        this.GET_INFOGRAPHIC = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}`);
        this.GET_TEXTBOOK_DEMO = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_DEMO_ID}`);
        this.GET_TEXTBOOK_PAGES = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/pages`);
        this.GET_INFOGRAPHIC_PAGES = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}/pages`);
        this.GET_TEXTBOOK_DEMO_PAGES = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_DEMO_ID}/pages`);
        this.GET_TEXTBOOK_TEXTUAL_PAGES = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/textual-pages`);
        this.GET_INFOGRAPHIC_TEXTUAL_PAGES = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}/textual-pages`);
        this.GET_TEXTBOOK_DEMO_TEXTUAL_PAGES = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_DEMO_ID}/textual-pages`);
        this.GET_TEXTBOOK_PAGE_BY_ID = new TextbookClientEndpoint(`/textbook-pages/${UrlParams.TEXTBOOK_PAGE_ID}`);
        this.GET_TEXTBOOK_PAGE_BY_TEXTBOOK_ID_AND_PAGE_NUMBER = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/pages/${UrlParams.PAGE_NUMBER}`);
        this.GET_TEXTBOOK_ACTION_GROUPS = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/action-groups`);
        this.GET_INFOGRAPHIC_ACTION_GROUPS = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}/action-groups`);
        this.GET_TEXTBOOK_DEMO_ACTION_GROUPS = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_ID}/action-groups`);
        this.GET_TEXTBOOK_ACTIONS = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/actions`);
        this.GET_INFOGRAPHIC_ACTIONS = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}/actions`);
        this.GET_TEXTBOOK_DEMO_ACTIONS = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_DEMO_ID}/actions`);
        this.GET_TEXTBOOK_ACTION_TRIGGERS = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/action-triggers`);
        this.GET_INFOGRAPHIC_ACTION_TRIGGERS = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}/action-triggers`);
        this.GET_TEXTBOOK_DEMO_ACTION_TRIGGERS = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_ID}/action-triggers`);
        this.GET_TEXTBOOK_ACTION_BY_ID = new TextbookClientEndpoint(`/textbook-actions/${UrlParams.ACTION_ID}`);
        this.GET_INFOGRAPHIC_ACTION_BY_ID = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}/actions/${UrlParams.ACTION_ID}`);
        this.GET_TEXTBOOK_DEMO_ACTION_BY_ID = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_DEMO_ID}/actions/${UrlParams.ACTION_ID}`);
        this.GET_TEXTBOOK_LEGEND = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/legend`);
        this.GET_INFOGRAPHIC_LEGEND = new TextbookClientEndpoint(`/infographic-textbooks/${UrlParams.TEXTBOOK_ID}/legend`);
        this.GET_TEXTBOOK_DEMO_LEGEND = new TextbookClientEndpoint(`/demo-textbooks/${UrlParams.TEXTBOOK_DEMO_ID}/legend`);
        this.GET_RESOURCE = new TextbookClientEndpoint(`/resources/${UrlParams.RESOURCE_ID}`);
        this.GET_RESOURCES = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/resources`);
        this.CREATE_MARKER = new TextbookClientEndpoint(`/markers`, HTTPMethod.POST);
        this.UPDATE_MARKER = new TextbookClientEndpoint(`/markers/${UrlParams.MARKER_ID}`, HTTPMethod.PATCH);
        this.DELETE_MARKER = new TextbookClientEndpoint(`/markers/${UrlParams.MARKER_ID}`, HTTPMethod.DELETE);
        this.GET_MARKERS = new TextbookClientEndpoint(`/markers`);
        this.GET_TEXTBOOK_MARKERS = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/markers`);
        this.GET_TEXTBOOK_PAGE_MARKERS = new TextbookClientEndpoint(`/textbook-pages/${UrlParams.TEXTBOOK_PAGE_ID}/markers`);
        this.CREATE_NOTE = new TextbookClientEndpoint(`/notes`, HTTPMethod.POST);
        this.UPDATE_NOTE = new TextbookClientEndpoint(`/notes/${UrlParams.NOTE_ID}`, HTTPMethod.PATCH);
        this.DELETE_NOTE = new TextbookClientEndpoint(`/notes/${UrlParams.NOTE_ID}`, HTTPMethod.DELETE);
        this.GET_NOTES = new TextbookClientEndpoint(`/notes`);
        this.GET_TEXTBOOK_NOTES = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/notes`);
        this.GET_TEXTBOOK_PAGE_NOTES = new TextbookClientEndpoint(`/textbook-pages/${UrlParams.TEXTBOOK_PAGE_ID}/notes`);
        this.GET_ACTION_NOTE = new TextbookClientEndpoint(`/textbook-actions/${UrlParams.ACTION_ID}/action-note`);
        this.GET_ALL_ACTION_NOTES = new TextbookClientEndpoint(`/action-notes`);
        this.GET_TEXTBOOK_ACTION_NOTES = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/action-notes`);
        this.CREATE_ACTION_NOTE = new TextbookClientEndpoint(`/action-notes`, HTTPMethod.POST);
        this.UPDATE_ACTION_NOTE = new TextbookClientEndpoint(`/action-notes/${UrlParams.ACTION_NOTE_ID}`, HTTPMethod.PATCH);
        this.DELETE_ACTION_NOTE = new TextbookClientEndpoint(`/action-notes/${UrlParams.ACTION_NOTE_ID}`, HTTPMethod.DELETE);
        this.LOGIN_WITH = new TextbookClientEndpoint(`/user-tokens`, HTTPMethod.POST);
        this.GET_AUTHENTICATED_USER = new TextbookClientEndpoint(`/users/me`);
        this.RECREATE_AUTHENTICATED_USER = new TextbookClientEndpoint(`/users/me`, HTTPMethod.POST);
        this.RECREATE_USER_TOKEN = new TextbookClientEndpoint(`/user-tokens`, HTTPMethod.PATCH);
        this.LOGOUT = new TextbookClientEndpoint(`/user-tokens`, HTTPMethod.DELETE);
        this.RUN_TEXTBOOK_ACCESS = new TextbookClientEndpoint(`/user-textbook-accesses/${UrlParams.ACCESS_ID}/run`, HTTPMethod.POST);
        this.DOWNLOAD_TEXTBOOK_ACCESS = new TextbookClientEndpoint(`/user-textbook-accesses/${UrlParams.ACCESS_ID}/download`, HTTPMethod.POST);
        this.UNINSTALL_MANY_TEXTBOOK_ACCESSES = new TextbookClientEndpoint(`/user-textbook-accesses/uninstall`, HTTPMethod.POST);
        this.CREATE_DRAWING = new TextbookClientEndpoint(`/drawings`, HTTPMethod.POST);
        this.UPDATE_DRAWING = new TextbookClientEndpoint(`/drawings/${UrlParams.DRAWING_ID}`, HTTPMethod.PATCH);
        this.DELETE_DRAWING = new TextbookClientEndpoint(`/drawings/${UrlParams.DRAWING_ID}`, HTTPMethod.DELETE);
        this.GET_DRAWINGS = new TextbookClientEndpoint(`/drawings`);
        this.GET_SINGLE_DRAWING = new TextbookClientEndpoint(`/drawings/${UrlParams.DRAWING_ID}`);
        this.GET_TEXTBOOK_DRAWINGS = new TextbookClientEndpoint(`/textbooks/${UrlParams.TEXTBOOK_ID}/drawings`);
        this.GET_ACTION_DRAWINGS = new TextbookClientEndpoint(`/textbook-actions/${UrlParams.ACTION_ID}/drawing`);
        this.GET_TEXTBOOK_PREMIUM_REDIRECTION = new TextbookClientEndpoint(`/premium-textbook-redirections/${UrlParams.TEXTBOOK_ID}`);
        this.GET_APP_MESSAGE = new TextbookClientEndpoint(`/app-message`);
        this.initEnum('TextbookClientEndpointEnum');
    }
    byUrlAndMethod(url, method) {
        return this.byDescription(TextbookClientEndpoint.buildDescription(url, method));
    }
}
const TextbookClientEndpointEnum = new TextbookClientEndpointEnumType();

/**
 * Generated bundle index. Do not edit.
 */

export { ActionType, MessagePeriodicityEnum, MessageTypeEnum, TextbookClient, TextbookClientEndpoint, TextbookClientEndpointEnum, UrlParams };

//# sourceMappingURL=gwo-textbook-api-client.js.map